/**
 * AssessmentDraftHelp — collapsible "How this works" panel for the Initial
 * Assessment Drafter (X.3.5 → X.6.4B reskin). Mirrors EmailDraftHelp: cream
 * card, gold left-accent, forest heading, default collapsed (founder ruling 2026-07-06). Copy + behavior + test
 * ids unchanged; inline hexes migrated to x.6.1 tokens, glyph → Lucide chevron.
 * LP-31: the panel carries Amanda's one line; the form, the follow-up
 * questions and the save hint explain the rest where they appear.
 */

import { type ReactNode, useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

export function AssessmentDraftHelp(): ReactNode {
  // Founder ruling 2026-07-06: collapsed by default — the panel is
  // reference, not a gate; the workspace leads.
  const [open, setOpen] = useState(false);

  return (
    <section
      className="overflow-hidden rounded-card border border-warm-400/25 border-l-[3px] border-l-warm-400 bg-cream"
      data-testid="assessment-draft-help"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between px-[18px] py-[13px] text-left text-sage-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400"
        data-testid="assessment-draft-help-toggle"
        aria-expanded={open}
      >
        <span className="font-display text-[15px] font-semibold">How this works</span>
        {open ? (
          <ChevronDown size={18} aria-hidden="true" className="text-sage-400" />
        ) : (
          <ChevronRight size={18} aria-hidden="true" className="text-sage-400" />
        )}
      </button>
      {open && (
        <div
          className="space-y-2 px-[18px] pb-4 text-[13px] leading-relaxed text-ink"
          data-testid="assessment-draft-help-body"
        >
          <p>Review every section before finalizing; the clinical judgment is yours.</p>
        </div>
      )}
    </section>
  );
}
